module.exports = __webpack_public_path__ + "static/media/tplayIcon.f86515ed.svg";